import React from 'react'
import './Button.scss'

interface ButtonProps {
  importance: 'danger' | 'secondary' | 'primary'
  disabled?: boolean
  onClick?: React.MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>
  className?: string
  text: string
  size?: 'regular' | 'small'
}

export const Button = function ({
  importance,
  disabled,
  onClick,
  className,
  text,
  size,
}: ButtonProps) {
  return (
    <button
      className={`re-button importance-${importance} ${
        onClick && !(disabled ?? false) ? 'clickable' : ''
      } ${disabled ?? false ? 'disabled' : ''} ${className ?? ''} size-${
        size ?? 'regular'
      }`}
      disabled={disabled}
      onClick={onClick}
    >
      <span className="text">{text}</span>
    </button>
  )
}
